export const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};
